import { useAuth } from "auth/useAuth";

/**
 * Get the enablement state of a feature flag.
 * @param flag The flag to look up.
 * @param defaultValue The default value to use if the flag does not exist.
 * @returns True if the flag is enabled, false otherwise.
 */
export function useFeatureFlag(flag: string, defaultValue?: boolean) {
    const featureFlags = useAuth((state) => state.featureFlags);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return -- this is what LaunchDarkly does
    return featureFlags[flag] ?? defaultValue;
}
